/* eslint-disable @typescript-eslint/no-explicit-any */

const timers: Record<string, NodeJS.Timeout | undefined> = {};

export function debounce<T extends (...args: any[]) => any>(callback: T, id = 'duplicated event', ms = 1000) {
  const timeout = timers[id];
  if (timeout) clearTimeout(timeout);
  return new Promise<ReturnType<T>>((resolve) => {
    timers[id] = setTimeout((rest: any) => {
      const returnValue = callback(rest) as ReturnType<T>;
      delete timers[id];
      resolve(returnValue);
    }, ms);
  });
}
